export default __webpack_public_path__ + "static/media/tick.29847191.svg";